import React, { createRef } from 'react';
import { SnackbarKey, SnackbarProvider } from 'notistack';
import { IconButton } from '@mui/material';

import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';

interface Props {
  children: React.ReactNode;
}

const NotiStackProvider = ({ children }: Props) => {
  const notistackRef = createRef<SnackbarProvider>();

  const onClickDismiss = (key: SnackbarKey) => () => {
    notistackRef.current?.closeSnackbar(key);
  };

  const iconStyle = { marginRight: 16 };

  return (
    <SnackbarProvider
      ref={notistackRef}
      action={(key) => (
        <IconButton onClick={onClickDismiss(key)}>
          <CloseRoundedIcon style={{ color: '#fff' }} />
        </IconButton>
      )}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      iconVariant={{
        success: <CheckCircleOutlineRoundedIcon style={iconStyle} />,
        error: <ErrorOutlineRoundedIcon style={iconStyle} />,
        warning: <WarningRoundedIcon style={iconStyle} />,
        info: <InfoRoundedIcon style={iconStyle} />,
      }}
    >
      {children}
    </SnackbarProvider>
  );
};

export default NotiStackProvider;
